import directusServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

const toSlugArray = (value?: string | string[]) => {
  if (!value) return []
  const list = Array.isArray(value) ? value : value.split(",")
  return list.map((v) => v.trim()).filter(Boolean)
}

const getAllPosts = async ({
  category,
  categoryExclude,
  limit = 8,
  page = 1,
  published = true,
  tag,
}: {
  page?: number
  limit?: number
  tag?: string | string[]
  category?: string | string[]
  categoryExclude?: string | string[]
  published?: boolean
} = {}) => {
  try {
    const tagSlugs = toSlugArray(tag)
    const categorySlugs = toSlugArray(category)
    const excludedCategorySlugs = toSlugArray(categoryExclude)
    const hasTagFilter = tagSlugs.length > 0
    const hasCategoryFilter = categorySlugs.length > 0
    const hasCategoryExclusion = excludedCategorySlugs.length > 0

    const response = await directusServer.query(
      `query allBlogPosts($page: Int, $limit: Int${hasTagFilter ? ", $tags: [String!]" : ""}${hasCategoryFilter ? ", $categories: [String!]" : ""}${hasCategoryExclusion ? ", $excludedCategories: [String!]" : ""}) {
				posts(
					sort:  "-date_created",
					filter: {
						${published ? 'status: { _eq: "published" }' : ""}
						${hasTagFilter ? "skills: { skills_id: { slug: { _in: $tags } } }" : ""}
						${
              hasCategoryFilter || hasCategoryExclusion
                ? `category: {
							${hasCategoryFilter ? "category_id: { slug: { _in: $categories } }" : ""}
							${hasCategoryExclusion ? "_none: { category_id: { slug: { _in: $excludedCategories } } }" : ""}
						}`
                : ""
            }
					}
					page: $page,
					limit: $limit,
				) {
					id,
					slug,
					date_created,
					title,
					headline,
					featured,
					role,
					evidence_metric,
					date_created
					read_time
					image {
						id
						width
						height
						filename_download
					}
					content_blocks {
						sort
						item {
							__typename
							... on project_overview {
								headline
							}
						}
					}
					skills(
						filter: { skills_id: { status: { _eq: "published" } } }
					) {
						skills_id(sort:  "-slug") {
							id
							slug
							name
							svg_logo
							description
							area
							icon_color
						}
					}
					category (
						filter: { category_id: { status: { _eq: "published" } } }
					) {
						category_id(sort:  "-slug") {
							id
							slug
							title
							image {
								id
							}
							description
							icon_color
							color
						}
					}
					author {
							name
							surname
							image {
								id
								width
								height
								filename_download
							}
					}
				}
			}`,
      {
        limit: limit,
        page: page,
        published: published,
        ...(hasTagFilter && { tags: tagSlugs }),
        ...(hasCategoryFilter && { categories: categorySlugs }),
        ...(hasCategoryExclusion && {
          excludedCategories: excludedCategorySlugs,
        }),
      }
    )

    // console.log(response);

    return response
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.error(error)
    return null
  }
}

export default getAllPosts
